import { useTranslation } from '@nextgen-web-framework/all';
import { useState } from 'react';

const usePasswordValidation = () => {
  const t = useTranslation();
  const [errors, setErrors] = useState<string[]>([]);
  const lengthError = t('identity.CreatePasswordForm.createPasswordError');
  const combinationError = t('identity.CreatePasswordForm.passwordCombinationError1');

  const validatePassword = (password: string) => {
    const PasswordRegex =
      /^(?=.*?\d)(?=.*?[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])(?=.*?[\u0E00-\u0E7F\u0370-\u03FF\u3040-\u309F\u30A0-\u30FFa-zA-Z])(?!.*?[^\u0E00-\u0E7F\u0370-\u03FF\u3040-\u309F\u30A0-\u30FFa-zA-Z0-9 !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,100}$/;

    const validations = [PasswordRegex.test(password), password.length >= 8];

    const valid = password.length >= 8 && validations.every(Boolean);

    setErrors(valid ? [] : [lengthError, combinationError]);
    return valid;
  };

  return [errors, validatePassword] as const;
};

export default usePasswordValidation;
